import { CharacterAndVersionFlatMerge, World } from "@src/types/global";
import './listWorlds.style.sass'
import Squircle from "../CharacterPortrait/Squircle";
import { useState } from "react";
import { animated, useSprings } from "@react-spring/web";
import CharacterCard from "../CharacterCard/CharacterCard";
import { useNavigate } from "react-router";
import { useCharacterStore } from "@src/stores/characterStore";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/solid";
import { deleteWorld } from "@src/services/requests/worlds";
import toast from "react-hot-toast";
import { useQueryClient } from "@tanstack/react-query";

interface IListWorldsProps {
    worlds: World[];
}
export const ListWorlds = ({ worlds }: IListWorldsProps) => {
    const [selectedWorldId, setSelectedWorldId] = useState<null | string>(null)
    const { setCharacterList } = useCharacterStore()
    const isSelected = (id: string) => selectedWorldId === id
    const navigate = useNavigate()

    const from = {
        height: 80,
    }
    const to = {
        height: 600
    }
    const [springs, api] = useSprings(
        worlds.length || 0,
        (i) => ({ from, reverse: isSelected(worlds[i].id || '') }),
        [],
    );
    function handleClick(index: number) {
        const world = worlds[index]
        const isWorldSelected = isSelected(world.id || '')
        api.current[index].start({ from, to, reverse: isSelected(world.id || '') })
        if (isWorldSelected) {
            setSelectedWorldId(null)
            return
        }
        setSelectedWorldId(world.id)
    }
    const handleUseAsStack = (versions: CharacterAndVersionFlatMerge[]) => {
        setCharacterList(versions)
    }
    const queryClient = useQueryClient()
    const handleDeleteWorld = async (id: string) => {
        const answer = confirm("Are you sure you want to delete this world?")
        if (answer) {
            try {
                await deleteWorld(id);
                toast.success("World deleted")

            } catch (e) {
                toast.error("Something went wrong, try again?")
            }
            try {
                const worldData = queryClient.getQueryData(["worlds", "own"])
                if (worldData) {
                    queryClient.setQueryData(["worlds", "own"], (data: { worlds: World[] }) => {
                        const newData = data?.worlds?.filter(world => world.id !== id)
                        return { worlds: newData }
                    })
                }
            } catch (e) {
                location.reload()
            }
        }
    }
    return <div className="world-wrapper">
        {springs.map((props, i) => {
            const world = worlds[i]
            return (
                <animated.div className="world" key={world.id} onClick={() => handleClick(i)} style={props} >
                    <div
                        className="world__bg"
                        style={{ backgroundImage: `url(${world.cover_image})` }}
                    >
                        <div className="world__bg__overlay"></div>
                        <Squircle />
                    </div>
                    <div className="world__info">
                        <h2 className="world__name">{world.name}</h2>
                        <div className="world__actions">
                            <button className="world__add" onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                handleUseAsStack(world.character_versions)
                            }}>Use as stack</button>
                            <button
                                type="button"
                                className="world__edit"
                                title={`Edit world ${world.name || ""}`}
                                onClick={(e) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    navigate("edit/" + world.id)

                                }}
                            >
                                <PencilIcon /> Edit
                            </button>
                            <button
                                type="button"
                                className="world__edit"
                                title={`Edit world ${world.name || ""}`}
                                onClick={(e) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    handleDeleteWorld(world.id || "")

                                }}
                            >
                                <TrashIcon /> Delete
                            </button>
                        </div>
                    </div>
                    <div className="world__characters">
                        {world.character_versions?.map(version => {
                            const cheekyVersion = { ...version, default_version: { ...version, id: version.version_id } };
                            return <CharacterCard character={cheekyVersion} type="vertical"
                                key={version.version_id}
                                onClick={() =>
                                    navigate(`/${version.id}`)
                                } />
                        }
                        )}
                    </div>
                </animated.div>
            )
        })}
    </div >

}
